import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type { FieldInterface } from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { FIELD_RULES } from 'src/tpbp-core/models/fields/fieldRules.const'

const dynamicRules = [
  {
    type: FIELD_RULES.isMandatory,
    expression: () => true,
  },
]

const realEstateHolderFields: FieldInterface[] = [
  {
    key: 'id',
    originKey: 'id',
    type: FIELD_TYPES.string,
    dynamicRules,
  },
  {
    key: 'label',
    originKey: 'label',
    type: FIELD_TYPES.string,
    dynamicRules,
  },
  {
    key: 'fullOwnershipPart',
    originKey: 'fullOwnershipPart',
    type: FIELD_TYPES.number,
    dynamicRules,
  },
  {
    key: 'bareOwnershipPart',
    originKey: 'bareOwnershipPart',
    type: FIELD_TYPES.number,
    dynamicRules,
  },
  {
    key: 'usufructPart',
    originKey: 'usufructPart',
    type: FIELD_TYPES.number,
    dynamicRules,
  },
  {
    key: 'isSelected',
    originKey: 'isSelected',
    type: FIELD_TYPES.boolean,
    dynamicRules,
  },
  {
    key: 'isMain',
    originKey: 'isMain',
    type: FIELD_TYPES.boolean,
    dynamicRules,
  },
]

export { realEstateHolderFields }
